<div class="flex flex-col space-y-6 px-6 py-4">
  <section class="grid grid-cols-3 gap-x-4">
    <div class="col-span-1">
      <app-total-scheduled-card></app-total-scheduled-card>
    </div>
    <div class="col-span-2">
      <app-top-usage-chart></app-top-usage-chart>
    </div>
  </section>
  <section>
    <div class="">
      <app-execution-history-table></app-execution-history-table>
    </div>
  </section>
</div>
